/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GoogleReviewView = {
    /**
     * Full Google review resource name
     */
    reviewId?: string;
    reviewerName?: string;
    reviewerAvatarInitials?: string;
    rating?: number;
    text?: string;
    createdAt: string;
    status?: GoogleReviewView.status;
    existingReply?: string | null;
    draftText?: string | null;
};
export namespace GoogleReviewView {
    export enum status {
        NEEDS_REPLY = 'needs_reply',
        DRAFT = 'draft',
        PUBLISHED = 'published',
    }
}

